(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8982],{

/***/ 915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/[canais]/[videos]",
      function () {
        return __webpack_require__(4983);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8802,7590,3739,9774,2888,179], function() { return __webpack_exec__(915); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);